import React from "react"
import { connect } from "react-redux"

import Header from "./../ui/Header"
import Container from "./../ui/Container"
import PageTitle from "./../ui/PageTitle"
import { RoomOutlined, PhoneOutlined, ScheduleOutlined } from "@material-ui/icons"

import "./Contacts.css"

const PHONES = [
  { label: "0372 54 38 90", href: "tel:+380372543890" },
  { label: "(067) 37 24 364", href: "tel:+380673724364" },
  { label: "(097) 22 36 790", href: "tel:+380972236790" },
]

const Contacts = ({ translation }) => {
  return (
    <div className="Contacts">
      <Header />
      <PageTitle title={translation.language === "ua" ? "Контакти" : "Контакты"} />
      <Container>
        <div className="Contacts--content">
          <section className="Contacts--row">
            <RoomOutlined className="Contacts--icon" />
            <h2 className="Contact--title">
              {translation.language === "ua" && "Адреса"}
              {translation.language === "ru" && "Адрес"}
            </h2>
            <div className="Contacts--items">
              <p>
                {translation.language === "ua" && "м. Чернівці, вул. Коломийська 9Д"}
                {translation.language === "ru" && "г. Черновцы, ул. Коломыйская 9Д"}
              </p>
            </div>
          </section>
          <section className="Contacts--row">
            <PhoneOutlined className="Contacts--icon" />
            <h2 className="Contact--title">
              {translation.language === "ua" && "Зв'яжіться з нами"}
              {translation.language === "ru" && "Свяжитесь с нами"}
            </h2>
            <div className="Contacts--items">
              <p>
                <span className="bold">
                  {translation.language === "ua" && "Телефони: "}
                  {translation.language === "ru" && "Телефоны: "}
                </span>
                {PHONES.map((phone, index) => (
                  <React.Fragment key={phone.href}>
                    <a href={phone.href}>{phone.label}</a>
                    {index < PHONES.length - 1 && ", "}
                  </React.Fragment>
                ))}
              </p>
              <p>
                <span className="bold">Факс: </span>
                0372 54 38 89
              </p>
              <p>
                <span className="bold">Емейл: </span>
                <a href="mailto:manager@yva.com.ua">manager@yva.com.ua</a>
              </p>
            </div>
          </section>
          <section className="Contacts--row">
            <ScheduleOutlined className="Contacts--icon" />
            <h2 className="Contact--title">
              {translation.language === "ua" && "Розклад"}
              {translation.language === "ru" && "Время работы"}
            </h2>
            <div className="Contacts--items">
              <p>
                <span className="bold">
                  {translation.language === "ua" && "Понеділок - П'ятниця: "}
                  {translation.language === "ru" && "Понедельник - П'ятница: "}
                </span>
                08:30 - 17:20
              </p>
              <p>
                {translation.language === "ua" && (
                  <>
                    <span className="bold">Субота: </span>
                    вихідний
                  </>
                )}
                {translation.language === "ru" && (
                  <>
                    <span className="bold">Суббота: </span>
                    выходной
                  </>
                )}
              </p>
            </div>
          </section>
        </div>
      </Container>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    translation: state.translationReducer
  }
}

export default connect(mapStateToProps)(Contacts)
